import { Navigate, useLocation } from 'react-router'
import { lastModule } from '@/lib/lastModule'

/**
 * `/taken` (the old global page): forwards to "Mijn taken" in the module used last, else
 * pre-invest, and keeps the query string (spec-64 U-011).
 */
export function TasksRedirect() {
  const { search } = useLocation()
  return <Navigate to={`/${lastModule() ?? 'preinvest'}/taken${search}`} replace />
}
